export const STATUS_ADDITIONAL_DATA_EVENT = "RealQueue/Status/AdditionalData";
